module.exports = __webpack_public_path__ + "static/media/3.93012910.jpg";